import GetAllProduct from '../components/products/GetAllProduct';
import AddProduct from '../components/products/Addproduct';

const ProductGrid = () => {


  return (
    <div className="container mx-auto p-8">
      <AddProduct />

        <GetAllProduct />
    </div>
  );
};

export default ProductGrid;
